import { withDefaultCurrency } from 'common/utils/formatUtils';
import {
  ProductStatus,
  SupplementaryPensionSavingsProductFragment,
  SupplementaryPensionSavingsProductInput,
} from 'generated/graphql';

export type MapSupplementaryPensionSavingsProductToInput = (
  product?: SupplementaryPensionSavingsProductFragment,
) => SupplementaryPensionSavingsProductInput;

export const mapSupplementaryPensionSavingsProductToInput: MapSupplementaryPensionSavingsProductToInput = (
  product = {
    creationTimestamp: new Date(),
    documents: [],
    enableFinancialAdvisorCare: true,
    enableNotifications: true,
    id: '',
    status: ProductStatus.Active,
    statusChangeDate: new Date(),
  },
) => {
  return {
    contractEndDate: product.contractEndDate,
    contractNumber: product.contractNumber,
    contractSignDate: product.contractSignDate,
    currentMarketValue: withDefaultCurrency(product.currentMarketValue),
    employeeContribution: withDefaultCurrency(product.employeeContribution),
    employerContribution: withDefaultCurrency(product.employerContribution),
    enableFinancialAdvisorCare: product.enableFinancialAdvisorCare,
    enableNotifications: product.enableNotifications,
    financialDetailsUpdatedAt: new Date(),
    guaranteedFund: product.guaranteedFund,
    institutionId: product.institution?.id,
    institutionName: product.institutionName,
    name: product.name,
    nonGuaranteedFund: product.nonGuaranteedFund,
    note: product.note,
    paymentInfo: {
      constantSymbol: product.paymentInfo?.constantSymbol,
      ibanForPayment: product.paymentInfo?.ibanForPayment,
      specificSymbol: product.paymentInfo?.specificSymbol,
      variableSymbol: product.paymentInfo?.variableSymbol,
    },
    paymentPeriod: {
      expectedAmount: withDefaultCurrency(product.paymentPeriod?.expectedAmount),
      periodCount: product.paymentPeriod?.periodCount,
      periodTypeCode: product.paymentPeriod?.periodTypeCode,
      referenceDate: product.paymentPeriod?.expectedDate,
    },
    possibleEmployerContribution: product.possibleEmployerContribution,
    status: product.status,
    statusChangeDate: product.statusChangeDate,
  };
};
